import React from "react"
import { useTranslation } from "next-i18next"
import { Button } from "@kohler-dsm-library/kohler-core"
import { getTranslations } from "@/components/GlobalVisualSearch/localization"
import { getCategoryURL } from "@/components/VisualSearch/v1/ComingSoon/utils"
import Style from "@/components/GlobalVisualSearch/ComingSoon/comingSoon.module.scss"

const ComingSoon = props => {
  const { category } = props
  const categorySelected = category?.toLowerCase()
  const { t } = useTranslation()
  const {
    recognitionCategory = () => {},
    recognitionCategorySubText = () => {},
    viewGuidtext,
    commingSoon,
  } = getTranslations(t)

  const viewGuide = () => {
    const supportUrl = getCategoryURL(category)
    window.open(supportUrl, "_blank")
  }

  return (
    <div className={Style.ComingSoonContainer}>
      <div className="para-section">
        <p className="working-para">{commingSoon}</p>
        <div className="button-section">
          <p className="para-two-section">
            {recognitionCategory(categorySelected)}
            <span className="secong-line">
              {recognitionCategorySubText(categorySelected)}
            </span>
          </p>
        </div>
        <Button
          size="small"
          className="view-button"
          variant="secondary"
          onClick={viewGuide}
        >
          {viewGuidtext}
        </Button>
      </div>
    </div>
  )
}

export default ComingSoon
